import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHub16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconHub16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.496 3.222a1.166 1.166 0 1 0-1-.004v1.91a2.9 2.9 0 0 0-1.737 1.007l-1.65-.952a1.166 1.166 0 1 0-.504.864l1.655.955a2.9 2.9 0 0 0 .004 2.007l-1.648.951a1.166 1.166 0 1 0 .495.87l1.655-.956c.433.516 1.042.88 1.734.999v1.907a1.166 1.166 0 1 0 1 0v-1.907a2.9 2.9 0 0 0 1.74-1.007l1.65.952a1.166 1.166 0 1 0 .504-.864L10.74 9a2.9 2.9 0 0 0-.004-2.007l1.65-.952a1.166 1.166 0 1 0-.497-.868l-1.654.955a2.9 2.9 0 0 0-1.74-1zM8 9.916a1.916 1.916 0 1 0 0-3.831 1.916 1.916 0 0 0 0 3.83"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHub16);
